import React from 'react';
import './header.css'
import { Link } from 'react-router-dom';

const Header = (props) => {
    return (
        <header className='header-container'>
        <Link to={props.link}>
            <button className='circlecta-cont' onClick={props.onClick2}>
                <img src={props.img} alt={props.icontext}></img>
            </button>
        </Link>
                 <div className='header-title-cont'>
                    <h2 className='title-containerr'>{props.title}</h2>
                    <h2 className='title2-container'>{props.title2}</h2>
                 </div>
        
            <button className='circlecta-cont'   onClick={props.onClick}>
                <img src={props.img2} alt={props.icontext2}></img>
            </button>
      


        </header>

       
      );
}
 
export default Header;